import Vue from 'vue';
import VueRouter from 'vue-router';

//Views
import Home from './views/Home'
import Login from './views/Login'
import Change from './views/Change'
import ResetPassword from './views/ResetPassword'

//Components
import ListarEmpresas from './components/Cadastro/Empresa/Lista'
import CriarEmpresa from './components/Cadastro/Empresa/Criar'
import EditarEmpresa from './components/Cadastro/Empresa/Editar'

import ListarLocal from './components/Cadastro/Local/Lista'
import CriarLocal from './components/Cadastro/Local/Criar'
import EditarLocal from './components/Cadastro/Local/Editar'

import ListarFornecedores from './components/Cadastro/Fornecedor/Lista'
import CriarFornecedor from './components/Cadastro/Fornecedor/Criar'
import EditarFornecedor from './components/Cadastro/Fornecedor/Editar'

import ListarLimites from './components/Cadastro/Limite/Lista'
import CriarLimite from './components/Cadastro/Limite/Criar'
import EditarLimite from './components/Cadastro/Limite/Editar'

import ListarPodutosServicos from './components/Cadastro/ProdutoServico/Lista'
import CriarProdutoServico from './components/Cadastro/ProdutoServico/Criar'
import EditarProdutoServico from './components/Cadastro/ProdutoServico/Editar'
import ListarMarcas from './components/Cadastro/Marca/Lista'
import CriarMarca from './components/Cadastro/Marca/Criar'
import EditarMarca from './components/Cadastro/Marca/Editar'

import ListarUnidadesMedida from './components/Cadastro/UnidadeMedida/Lista'
import CriarUnidadeMedida from './components/Cadastro/UnidadeMedida/Criar'
import EditarUnidadeMedida from './components/Cadastro/UnidadeMedida/Editar'

import FiltroAgrupado from './components/Teste/TableInlineFilter'
import FiltroVue2 from './components/Teste/TableColumnMenuFilter'
import FiltroMultiSelect from './components/Teste/ColumnMultiSelectFilter'

Vue.use(VueRouter);

const router = new VueRouter({
    base: process.env.BASE_URL,
    mode: 'hash',
    routes: [
        { path: '/login', component: Login },
        { path: '/change', component: Change },
        { path: "/resetPassword", component: ResetPassword },
        { path: '/filtroagr', component: FiltroAgrupado },
        { path: '/filtrov2', component: FiltroVue2 },
        { path: '/filtroms', component: FiltroMultiSelect },
        {
            path: '/',
            component: Home,
            children: [{
                name: 'Dashboard',
                path: '/',
                component: () =>
                    import('@/components/Dashboard'),
            },]
        },
        {
            path: '/',
            component: Home,
            children: [{
                path: '/administrador',
                name: 'Administrador',
                component: () =>
                    import('./components/Administrador.vue')
            }]
        },
        {
            path: '/',
            component: Home,
            children: [{
                path: '/centrocusto',
                name: 'CentroCusto',
                component: () =>
                    import('./components/CentroCusto.vue')
            }]
        },
        {
            path: '/',
            component: Home,
            children: [{
                path: '/almoxarifado',
                name: 'Almoxarifado',
                component: () =>
                    import('./components/Almoxarifado.vue')
            }]
        },
        {
            path: '/',
            component: Home,
            children: [{
                path: '/mapacompra',
                name: 'MapaCompra',
                component: () =>
                    import('./components/MapaCompra.vue')
            }]
        },
        {
            path: '/acessos',
            redirect: '/usuario',
            meta: { codModulo: '1' },
        },
        {
            path: '/usuario',
            component: Home,
            children: [{
                path: '',
                component: () =>
                    import('./components/Cadastro/Usuario/Lista.vue'),
                meta: { codModulo: 1, readonly: 1 },
            },
            {
                path: 'criar',
                component: () =>
                    import('./components/Cadastro/Usuario/Criar.vue'),
                meta: { codModulo: 1, readonly: 0 },
            },
            {
                path: 'editar',
                component: () =>
                    import('./components/Cadastro/Usuario/Editar.vue'),
                meta: { codModulo: 1, readonly: 0 },
            },
            {
                path: 'ver',
                component: () =>
                    import('./components/Cadastro/Usuario/Editar.vue'),
                meta: { codModulo: 1, readonly: 1 },
            },
            ],
            meta: { codModulo: 1 },
        },
        {
            path: '/cargo',
            component: Home,
            children: [{
                path: '',
                component: () =>
                    import('./components/Cadastro/Cargo/Lista.vue'),
                meta: { codModulo: 1, readonly: 1 },
            },
            {
                path: 'criar',
                component: () =>
                    import('./components/Cadastro/Cargo/Criar.vue'),
                meta: { codModulo: 1, readonly: 0 },
            },
            {
                path: 'editar',
                component: () =>
                    import('./components/Cadastro/Cargo/Editar.vue'),
                meta: { codModulo: 1, readonly: 0 },
            },
            {
                path: 'ver',
                component: () =>
                    import('./components/Cadastro/Cargo/Editar.vue'),
                meta: { codModulo: 1, readonly: 1 },
            },
            ],
            meta: { codModulo: 1 },
        },
        {
            path: '/perfil',
            component: Home,
            children: [{
                path: '',
                component: () =>
                    import('./components/Cadastro/Perfil/Lista.vue'),
                meta: { codModulo: 1, readonly: 1 },
            },
            {
                path: 'criar',
                component: () =>
                    import('./components/Cadastro/Perfil/Criar.vue'),
                meta: { codModulo: 1, readonly: 0 },
            },
            {
                path: 'editar',
                component: () =>
                    import('./components/Cadastro/Perfil/Editar.vue'),
                meta: { codModulo: 1, readonly: 0 },
            },
            {
                path: 'ver',
                component: () =>
                    import('./components/Cadastro/Perfil/Editar.vue'),
                meta: { codModulo: 1, readonly: 1 },
            },
            ],
            meta: { codModulo: 1 },
        },
        {
            path: '/permissao',
            component: Home,
            children: [{
                path: '',
                component: () =>
                    import('./components/Cadastro/Permissao/Lista.vue'),
                meta: { codModulo: 1, readonly: 1 },
            },
            {
                path: 'criar',
                component: () =>
                    import('./components/Cadastro/Permissao/Criar.vue'),
                meta: { codModulo: 1, readonly: 0 },
            },
            {
                path: 'editar',
                component: () =>
                    import('./components/Cadastro/Permissao/Editar.vue'),
                meta: { codModulo: 1, readonly: 0 },
            },
            {
                path: 'ver',
                component: () =>
                    import('./components/Cadastro/Permissao/Editar.vue'),
                meta: { codModulo: 1, readonly: 1 },
            },
            ],
            meta: { codModulo: 1 },
        },
        {
            path: '/empresa',
            component: Home,
            meta: { codModulo: '2' },
            children: [{
                path: '',
                component: ListarEmpresas,
                meta: { codModulo: 2, readonly: 1 },
            },
            {
                path: 'criar',
                component: CriarEmpresa,
                meta: { codModulo: 2, readonly: 0 },
            },
            {
                path: 'editar',
                component: EditarEmpresa,
                meta: { codModulo: 2, readonly: 0 },
            },
            {
                path: 'ver',
                component: EditarEmpresa,
                meta: { codModulo: 2, readonly: 1 },
            },
            ]
        },
        {
            path: '/fornecedor',
            component: Home,
            meta: { codModulo: '4' },
            children: [{
                path: '',
                component: ListarFornecedores,
                meta: { codModulo: 4, readonly: 1 },
            },
            {
                path: 'criar',
                component: CriarFornecedor,
                meta: { codModulo: 4, readonly: 0 },
            },
            {
                path: 'editar',
                component: EditarFornecedor,
                meta: { codModulo: 4, readonly: 0 },
            },
            {
                path: 'ver',
                component: EditarFornecedor,
                meta: { codModulo: 4, readonly: 1 },
            },
            ]
        },
        {
            path: '/limite',
            component: Home,
            children: [{
                path: '',
                component: ListarLimites,
                meta: { codModulo: 5, readonly: 1 },
            },
            {
                path: 'criar',
                component: CriarLimite,
                meta: { codModulo: 5, readonly: 0 },
            },
            {
                path: 'editar',
                component: EditarLimite,
                meta: { codModulo: 5, readonly: 0 },
            },
            {
                path: 'ver',
                component: EditarLimite,
                meta: { codModulo: 5, readonly: 1 },
            },
            ]
        },
        {
            path: '/Local',
            component: Home,
            children: [{
                path: '',
                component: ListarLocal,
                meta: { codModulo: 7, readonly: 1 },
            },
            {
                path: 'criar',
                component: CriarLocal,
                meta: { codModulo: 7, readonly: 0 },
            },
            {
                path: 'editar',
                component: EditarLocal,
                meta: { codModulo: 7, readonly: 0 },
            },
            ]
        },
        {
            path: '/produtoseservicos',
            redirect: '/produto&servico'
        },
        {
            path: '/produto&servico',
            component: Home,
            children: [{
                path: '',
                redirect: 'lista'
            },
            {
                path: 'lista',
                component: ListarPodutosServicos,
                meta: { codModulo: 6, readonly: 1 },
            },
            {
                path: 'criar',
                component: CriarProdutoServico,
                meta: { codModulo: 6, readonly: 0 },
            },
            {
                path: 'editar',
                component: EditarProdutoServico,
                meta: { codModulo: 6, readonly: 0 },
            },
            {
                path: 'ver',
                component: EditarProdutoServico,
                meta: { codModulo: 6, readonly: 1 },
            },
            ]
        },
        {
            path: '/grupoProduto',
            component: Home,
            children: [{
                path: '',
                component: () =>
                    import('./components/Cadastro/GrupoProduto/Lista.vue'),
                meta: { codModulo: 6, readonly: 1 },
            },
            {
                path: 'criar',
                component: () =>
                    import('./components/Cadastro/GrupoProduto/Criar.vue'),
                meta: { codModulo: 6, readonly: 0 },
            },
            {
                path: 'editar',
                component: () =>
                    import('./components/Cadastro/GrupoProduto/Editar.vue'),
                meta: { codModulo: 6, readonly: 0 },
            },
            {
                path: 'ver',
                component: () =>
                    import('./components/Cadastro/GrupoProduto/Editar.vue'),
                meta: { codModulo: 6, readonly: 1 },
            },
            ]
        },
        {
            path: '/subGrupoProduto',
            component: Home,
            children: [{
                path: '',
                component: () =>
                    import('./components/Cadastro/SubGrupoProduto/Lista.vue'),
                meta: { codModulo: 6, readonly: 1 },
            },
            {
                path: 'criar',
                component: () =>
                    import('./components/Cadastro/SubGrupoProduto/Criar.vue'),
                meta: { codModulo: 6, readonly: 0 },
            },
            {
                path: 'editar',
                component: () =>
                    import('./components/Cadastro/SubGrupoProduto/Editar.vue'),
                meta: { codModulo: 6, readonly: 0 },
            },
            {
                path: 'ver',
                component: () =>
                    import('./components/Cadastro/SubGrupoProduto/Editar.vue'),
                meta: { codModulo: 6, readonly: 1 },
            },
            ]
        },
        {
            path: '/marca',
            component: Home,
            children: [{
                path: '',
                component: ListarMarcas,
                meta: { codModulo: 6, readonly: 1 },
            },
            {
                path: 'criar',
                component: CriarMarca,
                meta: { codModulo: 6, readonly: 0 },
            },
            {
                path: 'editar',
                component: EditarMarca,
                meta: { codModulo: 6, readonly: 0 },
            },
            {
                path: 'ver',
                component: EditarMarca,
                meta: { codModulo: 6, readonly: 1 },
            },
            ]
        },
        {
            path: '/unidadeMedida',
            component: Home,
            children: [{
                path: '',
                component: ListarUnidadesMedida,
                meta: { codModulo: 6, readonly: 1 },
            },
            {
                path: 'criar',
                component: CriarUnidadeMedida,
                meta: { codModulo: 6, readonly: 0 },
            },
            {
                path: 'editar',
                component: EditarUnidadeMedida,
                meta: { codModulo: 6, readonly: 0 },
            },
            {
                path: 'ver',
                component: EditarUnidadeMedida,
                meta: { codModulo: 6, readonly: 1 },
            },
            ]
        },
        {
            path: '/condicaoPagamento',
            component: Home,
            children: [{
                path: '',
                component: () =>
                    import('./components/Cadastro/CondicaoPagamento/Lista.vue'),
                meta: { codModulo: 6, readonly: 1 },
            },
            {
                path: 'criar',
                component: () =>
                    import('./components/Cadastro/CondicaoPagamento/Criar.vue'),
                meta: { codModulo: 6, readonly: 0 },
            },
            {
                path: 'editar',
                component: () =>
                    import('./components/Cadastro/CondicaoPagamento/Editar.vue'),
                meta: { codModulo: 6, readonly: 0 },
            },
            {
                path: 'ver',
                component: () =>
                    import('./components/Cadastro/CondicaoPagamento/Editar.vue'),
                meta: { codModulo: 6, readonly: 1 },
            },
            ]
        },
        {
            path: '/equipamentos',
            redirect: '/equipamento'
        },
        {
            path: '/equipamento',
            component: Home,
            children: [{
                path: '',
                redirect: 'lista'
            },
            {
                path: 'lista',
                component: () =>
                    import('./components/Cadastro/Equipamento/Lista.vue'),
                meta: { codModulo: 3, readonly: 1 },
            },
            {
                path: 'criar',
                component: () =>
                    import('./components/Cadastro/Equipamento/Criar.vue'),
                meta: { codModulo: 3, readonly: 0 },
            },
            {
                path: 'editar',
                component: () =>
                    import('./components/Cadastro/Equipamento/Editar.vue'),
                meta: { codModulo: 3, readonly: 0 },
            },
            {
                path: 'ver',
                component: () =>
                    import('./components/Cadastro/Equipamento/Editar.vue'),
                meta: { codModulo: 3, readonly: 1 },
            },
            ]
        },
        {
            path: '/implemento',
            component: Home,
            children: [{
                path: '',
                component: () =>
                    import('./components/Cadastro/Equipamento/Implemento/Criar.vue'),
                meta: { codModulo: 3, readonly: 1 },
            },
            {
                path: 'ver',
                component: () =>
                    import('./components/Cadastro/Equipamento/Implemento/Criar.vue'),
                meta: { codModulo: 3, readonly: 1 },
            },
            ]
        },
        {
            path: '/acessorio',
            component: Home,
            children: [{
                path: '',
                component: () =>
                    import('./components/Cadastro/Equipamento/Acessorio/Criar.vue'),
                meta: { codModulo: 3, readonly: 1 },
            },
            {
                path: 'ver',
                component: () =>
                    import('./components/Cadastro/Equipamento/Acessorio/Criar.vue'),
                meta: { codModulo: 3, readonly: 1 },
            },
            ]
        },
        {
            path: '/proprietario',
            component: Home,
            children: [{
                path: '',
                component: () =>
                    import('./components/Cadastro/Equipamento/Proprietario/Lista.vue'),
                meta: { codModulo: 3, readonly: 1 },
            },
            {
                path: 'criar',
                component: () =>
                    import('./components/Cadastro/Equipamento/Proprietario/Criar.vue'),
                meta: { codModulo: 3, readonly: 0 },
            },
            {
                path: 'editar',
                component: () =>
                    import('./components/Cadastro/Equipamento/Proprietario/Editar.vue'),
                meta: { codModulo: 3, readonly: 0 },
            },
            {
                path: 'ver',
                component: () =>
                    import('./components/Cadastro/Equipamento/Proprietario/Editar.vue'),
                meta: { codModulo: 3, readonly: 1 },
            },
            ]
        },
        {
            path: '/grupoEquipamento',
            component: Home,
            children: [{
                path: '',
                component: () =>
                    import('./components/Cadastro/Familia/Lista.vue'),
                meta: { codModulo: 3, readonly: 1 },
            },
            {
                path: 'criar',
                component: () =>
                    import('./components/Cadastro/Familia/Criar.vue'),
                meta: { codModulo: 3, readonly: 0 },
            },
            {
                path: 'editar',
                component: () =>
                    import('./components/Cadastro/Familia/Editar.vue'),
                meta: { codModulo: 3, readonly: 0 },
            },
            {
                path: 'ver',
                component: () =>
                    import('./components/Cadastro/Familia/Editar.vue'),
                meta: { codModulo: 3, readonly: 1 },
            },
            ]
        },
        {
            path: '/marcaEquipamento',
            component: Home,
            children: [{
                path: '',
                component: () =>
                    import('./components/Cadastro/MarcaEquipamento/Lista.vue'),
                meta: { codModulo: 3, readonly: 1 },
            },
            {
                path: 'criar',
                component: () =>
                    import('./components/Cadastro/MarcaEquipamento/Criar.vue'),
                meta: { codModulo: 3, readonly: 0 },
            },
            {
                path: 'editar',
                component: () =>
                    import('./components/Cadastro/MarcaEquipamento/Editar.vue'),
                meta: { codModulo: 3, readonly: 0 },
            },
            {
                path: 'ver',
                component: () =>
                    import('./components/Cadastro/MarcaEquipamento/Editar.vue'),
                meta: { codModulo: 3, readonly: 1 },
            },
            ]
        },
        {
            path: '/modelo',
            component: Home,
            children: [{
                path: '',
                component: () =>
                    import('./components/Cadastro/Modelo/Lista.vue'),
                meta: { codModulo: 3, readonly: 1 },
            },
            {
                path: 'criar',
                component: () =>
                    import('./components/Cadastro/Modelo/Criar.vue'),
                meta: { codModulo: 3, readonly: 0 },
            },
            {
                path: 'editar',
                component: () =>
                    import('./components/Cadastro/Modelo/Editar.vue'),
                meta: { codModulo: 3, readonly: 0 },
            },
            {
                path: 'ver',
                component: () =>
                    import('./components/Cadastro/Modelo/Editar.vue'),
                meta: { codModulo: 3, readonly: 1 },
            },
            ]
        },
        {
            path: '/capacidade',
            component: Home,
            children: [{
                path: '',
                component: () =>
                    import('./components/Cadastro/GrupoEquipamento/Lista.vue'),
                meta: { codModulo: 3, readonly: 1 },
            },
            {
                path: 'criar',
                component: () =>
                    import('./components/Cadastro/GrupoEquipamento/Criar.vue'),
                meta: { codModulo: 3, readonly: 0 },
            },
            {
                path: 'editar',
                component: () =>
                    import('./components/Cadastro/GrupoEquipamento/Editar.vue'),
                meta: { codModulo: 3, readonly: 0 },
            },
            {
                path: 'ver',
                component: () =>
                    import('./components/Cadastro/GrupoEquipamento/Editar.vue'),
                meta: { codModulo: 3, readonly: 1 },
            },
            ]
        },
        {
            path: '/controleFrota',
            component: Home,
            children: [{
                path: '',
                component: () =>
                    import('./components/Manutencao/ControleFrota/Lista.vue'),
                meta: { codModulo: 1, readonly: 1 },
            },
            {
                path: 'criar',
                component: () =>
                    import('./components/Manutencao/ControleFrota/Criar.vue'),
                meta: { codModulo: 1, readonly: 0 },
            },
            {
                path: 'editar',
                component: () =>
                    import('./components/Manutencao/ControleFrota/Editar.vue'),
                meta: { codModulo: 1, readonly: 0 },
            },
            {
                path: 'ver',
                component: () =>
                    import('./components/Manutencao/ControleFrota/Editar.vue'),
                meta: { codModulo: 1, readonly: 1 },
            },
            ]
        },
        {
            path: '/horimetroKM',
            component: Home,
            children: [{
                path: '',
                component: () =>
                    import('./components/Manutencao/HorimetroKM/Criar.vue'),
                meta: { codModulo: 7, readonly: 1 },
            },
            {
                path: 'ver',
                component: () =>
                    import('./components/Manutencao/HorimetroKM/Editar.vue'),
                meta: { codModulo: 7, readonly: 1 },
            },
            {
                path: 'editar',
                component: () =>
                    import('./components/Manutencao/HorimetroKM/Editar.vue'),
                meta: { codModulo: 7, readonly: 0 },
            }
            ]
        },
        {
            path: '/solicitacao',
            component: Home,
            children: [{
                path: '',
                component: () =>
                    import('./components/Compras/Solicitacao/Lista.vue'),
                meta: { codModulo: 9, readonly: 1 },
            },
            {
                path: 'criar',
                component: () =>
                    import('./components/Compras/Solicitacao/Criar.vue'),
                meta: { codModulo: 9, readonly: 0 },
            },
            {
                path: 'editar',
                component: () =>
                    import('./components/Compras/Solicitacao/Editar.vue'),
                meta: { codModulo: 9, readonly: 0 },
            },
            {
                path: 'ver',
                component: () =>
                    import('./components/Compras/Solicitacao/Editar.vue'),
                meta: { codModulo: 9, readonly: 1 },
            },
            {
                path: 'aprovar',
                component: () =>
                    import('./components/Compras/Solicitacao/Aprovar.vue'),
                meta: { codModulo: 9, readonly: 0 },
            },
            {
                path: 'inativar',
                component: () =>
                    import('./components/Compras/Solicitacao/Inativar.vue'),
                meta: { codModulo: 9, readonly: 0 },
            },
            ]
        },
        {
            path: '/pedido',
            component: Home,
            children: [{
                path: '',
                component: () =>
                    import('./components/Compras/Pedido/Lista.vue'),
                meta: { codModulo: 11, readonly: 1 },
            },
            {
                path: 'aprovar',
                component: () =>
                    import('./components/Compras/Pedido/Aprovar.vue'),
                meta: { codModulo: 11, readonly: 1 },
            },
            {
                path: 'enviar',
                component: () =>
                    import('./components/Compras/Pedido/Enviar.vue'),
                meta: { codModulo: 11, readonly: 0 },
            },
            {
                path: 'inativar',
                component: () =>
                    import('./components/Compras/Pedido/Inativar.vue'),
                meta: { codModulo: 11, readonly: 0 },
            }
            ]
        },
        {
            path: '/requisicao',
            component: Home,
            children: [{
                path: '',
                component: () =>
                    import('./components/Compras/Requisicao/Lista.vue'),
                meta: { codModulo: 8, readonly: 1 },
            },
            {
                path: 'criar',
                component: () =>
                    import('./components/Compras/Requisicao/Criar.vue'),
                meta: { codModulo: 8, readonly: 0 },
            },
            {
                path: 'editar',
                component: () =>
                    import('./components/Compras/Requisicao/Editar.vue'),
                meta: { codModulo: 8, readonly: 0 },
            },
            {
                path: 'ver',
                component: () =>
                    import('./components/Compras/Requisicao/Editar.vue'),
                meta: { codModulo: 8, readonly: 1 },
            },
            {
                path: 'aprovar',
                component: () =>
                    import('./components/Compras/Requisicao/Aprovar.vue'),
                meta: { codModulo: 8, readonly: 0 },
            },
            {
                path: 'inativar',
                component: () =>
                    import('./components/Compras/CancelarRequisicao/Editar.vue'),
                meta: { codModulo: 8, readonly: 0 },
            },
            ]
        },
        {
            path: '/requisicaoServico',
            component: Home,
            children: [{
                path: '',
                component: () =>
                    import('./components/Compras/RequisicaoServico/Lista.vue'),
                meta: { codModulo: 8, readonly: 1 },
            },
            {
                path: 'criar',
                component: () =>
                    import('./components/Compras/RequisicaoServico/Criar.vue'),
                meta: { codModulo: 8, readonly: 0 },
            },
            {
                path: 'editar',
                component: () =>
                    import('./components/Compras/RequisicaoServico/Editar.vue'),
                meta: { codModulo: 8, readonly: 0 },
            },
            {
                path: 'ver',
                component: () =>
                    import('./components/Compras/RequisicaoServico/Editar.vue'),
                meta: { codModulo: 8, readonly: 1 },
            },
            {
                path: 'aprovar',
                component: () =>
                    import('./components/Compras/RequisicaoServico/Aprovar.vue'),
                meta: { codModulo: 8, readonly: 0 },
            },
            {
                path: 'inativar',
                component: () =>
                    import('./components/Compras/RequisicaoServico/Inativar.vue'),
                meta: { codModulo: 8, readonly: 0 },
            },
            {
                path: 'pedido',
                component: () =>
                    import('./components/Compras/RequisicaoServico/Pedido.vue'),
                meta: { codModulo: 8, readonly: 0 },
            },
            {
                path: 'aprovarPedido',
                component: () =>
                    import('./components/Compras/RequisicaoServico/Pedido.vue'),
                props: { modoAprovacaoLimite: true },
                meta: { codModulo: 8, readonly: 1 },
            },
            ]
        },
        {
            path: '/cancelarRequisicao',
            component: Home,
            children: [{
                path: '',
                component: () =>
                    import('./components/Compras/CancelarRequisicao/Lista.vue'),
                meta: { codModulo: 8, readonly: 1 },
            },
            {
                path: 'criar',
                component: () =>
                    import('./components/Compras/CancelarRequisicao/Criar.vue'),
                meta: { codModulo: 8, readonly: 0 },
            },
            {
                path: 'editar',
                component: () =>
                    import('./components/Compras/CancelarRequisicao/Editar.vue'),
                meta: { codModulo: 8, readonly: 0 },
            },
            {
                path: 'ver',
                component: () =>
                    import('./components/Compras/CancelarRequisicao/Editar.vue'),
                meta: { codModulo: 8, readonly: 1 },
            },
            ]
        },
        {
            path: '/baixaRequisicao',
            component: Home,
            children: [{
                path: '',
                component: () =>
                    import('./components/Almoxarifado/Requisicao/Lista.vue'),
                meta: { codModulo: 8, readonly: 1 },
            },
            {
                path: 'baixar',
                component: () =>
                    import('./components/Almoxarifado/Requisicao/Baixar.vue'),
                meta: { codModulo: 8, readonly: 0 },
            },
            ]
        },
        {
            path: '/mapaCotacao',
            component: Home,
            children: [{
                path: '',
                component: () =>
                    import('./components/Compras/MapaCotacao/Lista.vue'),
                meta: { codModulo: 10, readonly: 1 },
            },
            {
                path: 'criar',
                component: () =>
                    import('./components/Compras/MapaCotacao/Criar.vue'),
                meta: { codModulo: 10, readonly: 1 },
            },
            {
                path: 'editar',
                component: () =>
                    import('./components/Compras/MapaCotacao/Editar.vue'),
                meta: { codModulo: 10, readonly: 0 },
            },
            {
                path: 'ver',
                component: () =>
                    import('./components/Compras/MapaCotacao/Inativar.vue'),
                meta: { codModulo: 10, readonly: 1 },
            },
            {
                path: 'inativar',
                component: () =>
                    import('./components/Compras/MapaCotacao/Inativar.vue'),
                meta: { codModulo: 10, readonly: 0 },
            },
            {
                path: 'aprovar',
                component: () =>
                    import('./components/Compras/MapaCotacao/Aprovar.vue'),
                meta: { codModulo: 10, readonly: 0 },
            },
            ]
        },
        {
            path: '/mecanico',
            component: Home,
            children: [{
                path: '',
                component: () =>
                    import('./components/Cadastro/Mecanico/Lista.vue'),
                meta: { codModulo: 13, readonly: 1 },
            },
            {
                path: 'criar',
                component: () =>
                    import('./components/Cadastro/Mecanico/Criar.vue'),
                meta: { codModulo: 13, readonly: 0 },
            },
            {
                path: 'editar',
                component: () =>
                    import('./components/Cadastro/Mecanico/Editar.vue'),
                meta: { codModulo: 13, readonly: 0 },
            },
            {
                path: 'ver',
                component: () =>
                    import('./components/Cadastro/Mecanico/Editar.vue'),
                meta: { codModulo: 13, readonly: 1 },
            },
            ]
        },
        {
            path: '/planoManutencao',
            component: Home,
            children: [{
                path: '',
                component: () =>
                    import('./components/Cadastro/PlanoManutencao/Lista.vue'),
                meta: { codModulo: 14, readonly: 1 },
            },
            {
                path: 'criar',
                component: () =>
                    import('./components/Cadastro/PlanoManutencao/Criar.vue'),
                meta: { codModulo: 14, readonly: 0 },
            },
            {
                path: 'editar',
                component: () =>
                    import('./components/Cadastro/PlanoManutencao/Editar.vue'),
                meta: { codModulo: 14, readonly: 0 },
            },
            {
                path: 'ver',
                component: () =>
                    import('./components/Cadastro/PlanoManutencao/Editar.vue'),
                meta: { codModulo: 14, readonly: 1 },
            },
            ]
        },
        {
            path: '/servicoPlano',
            component: Home,
            children: [{
                path: '',
                component: () =>
                    import('./components/Cadastro/ServicoPlano/Lista.vue'),
                meta: { codModulo: 14, readonly: 1 },
            },
            {
                path: 'criar',
                component: () =>
                    import('./components/Cadastro/ServicoPlano/Criar.vue'),
                meta: { codModulo: 14, readonly: 0 },
            },
            {
                path: 'editar',
                component: () =>
                    import('./components/Cadastro/ServicoPlano/Editar.vue'),
                meta: { codModulo: 14, readonly: 0 },
            },
            {
                path: 'ver',
                component: () =>
                    import('./components/Cadastro/ServicoPlano/Editar.vue'),
                meta: { codModulo: 14, readonly: 1 },
            },
            ]
        },
        {
            path: '/localizacao',
            component: Home,
            children: [{
                path: '',
                component: () =>
                    import('./components/Cadastro/Localizacao/Lista.vue'),
                meta: { codModulo: 16, readonly: 1 },
            },
            {
                path: 'criar',
                component: () =>
                    import('./components/Cadastro/Localizacao/Criar.vue'),
                meta: { codModulo: 16, readonly: 0 },
            },
            {
                path: 'editar',
                component: () =>
                    import('./components/Cadastro/Localizacao/Editar.vue'),
                meta: { codModulo: 16, readonly: 0 },
            },
            {
                path: 'ver',
                component: () =>
                    import('./components/Cadastro/Localizacao/Editar.vue'),
                meta: { codModulo: 16, readonly: 1 },
            },
            ]
        },
        {
            path: '/ordemServico',
            component: Home,
            children: [{
                path: '',
                component: () =>
                    import('./components/Manutencao/OrdemServico/Lista.vue'),
                meta: { codModulo: 17, readonly: 1 },
            },
            {
                path: 'criar',
                component: () =>
                    import('./components/Manutencao/OrdemServico/Criar.vue'),
                meta: { codModulo: 17, readonly: 0 },
            },
            {
                path: 'editar',
                component: () =>
                    import('./components/Manutencao/OrdemServico/Editar.vue'),
                meta: { codModulo: 17, readonly: 0 },
            },
            {
                path: 'ver',
                component: () =>
                    import('./components/Manutencao/OrdemServico/Editar.vue'),
                meta: { codModulo: 17, readonly: 1 },
            },
            ]
        },
        {
            path: '/chamadoManutencao',
            component: Home,
            children: [{
                path: '',
                component: () =>
                    import('./components/Manutencao/ChamadoManutencao/Lista.vue'),
                meta: { codModulo: 18, readonly: 1 },
            },
            {
                path: 'criar',
                component: () =>
                    import('./components/Manutencao/ChamadoManutencao/Criar.vue'),
                meta: { codModulo: 18, readonly: 0 },
            },
            {
                path: 'editar',
                component: () =>
                    import('./components/Manutencao/ChamadoManutencao/Editar.vue'),
                meta: { codModulo: 18, readonly: 0 },
            },
            {
                path: 'ver',
                component: () =>
                    import('./components/Manutencao/ChamadoManutencao/Editar.vue'),
                meta: { codModulo: 18, readonly: 1 },
            },
            ]
        },
        {
            path: '/protocoloEntrega',
            component: Home,
            children: [{
                path: '',
                component: () =>
                    import('./components/Almoxarifado/ProtocoloEntrega/Lista.vue'),
                meta: { codModulo: 19, readonly: 1 },
            },
            {
                path: 'criar',
                component: () =>
                    import('./components/Almoxarifado/ProtocoloEntrega/Criar.vue'),
                meta: { codModulo: 19, readonly: 0 },
            },
            {
                path: 'editar',
                component: () =>
                    import('./components/Almoxarifado/ProtocoloEntrega/Editar.vue'),
                meta: { codModulo: 19, readonly: 0 },
            },
            {
                path: 'ver',
                component: () =>
                    import('./components/Almoxarifado/ProtocoloEntrega/Editar.vue'),
                meta: { codModulo: 19, readonly: 1 },
            },
            ]
        },
        {
            path: '/entradaNF',
            component: Home,
            children: [{
                path: '',
                component: () =>
                    import('./components/Almoxarifado/Entrada/Lista.vue'),
                meta: { codModulo: 20, readonly: 1 },
            },
            {
                path: 'criar',
                component: () =>
                    import('./components/Almoxarifado/Entrada/Criar.vue'),
                meta: { codModulo: 20, readonly: 0 },
            },
            {
                path: 'editar',
                component: () =>
                    import('./components/Almoxarifado/Entrada/Editar.vue'),
                meta: { codModulo: 20, readonly: 0 },
            },
            {
                path: 'ver',
                component: () =>
                    import('./components/Almoxarifado/Entrada/Editar.vue'),
                meta: { codModulo: 20, readonly: 1 },
            },
            ]
        },
        {
            path: '/pedidoAvulso',
            component: Home,
            children: [{
                path: '',
                component: () =>
                    import('./components/Compras/PedidoAvulso/Lista.vue'),
                meta: { codModulo: 21, readonly: 1 },
            },
            {
                path: 'criar',
                component: () =>
                    import('./components/Compras/PedidoAvulso/Criar.vue'),
                meta: { codModulo: 21, readonly: 0 },
            },
            {
                path: 'editar',
                component: () =>
                    import('./components/Compras/PedidoAvulso/Editar.vue'),
                meta: { codModulo: 21, readonly: 0 },
            },
            {
                path: 'ver',
                component: () =>
                    import('./components/Compras/PedidoAvulso/Editar.vue'),
                meta: { codModulo: 21, readonly: 1 },
            },
            {
                path: 'inativar',
                component: () =>
                    import('./components/Compras/PedidoAvulso/Inativar.vue'),
                meta: { codModulo: 21, readonly: 0 },
            },
            ]
        },
        {
            path: '/periodicidade',
            component: Home,
            children: [{
                path: '',
                component: () =>
                    import('./components/Cadastro/Periodicidade/Lista.vue'),
                meta: { codModulo: 14, readonly: 1 },
            },
            {
                path: 'criar',
                component: () =>
                    import('./components/Cadastro/Periodicidade/Criar.vue'),
                meta: { codModulo: 14, readonly: 0 },
            },
            {
                path: 'editar',
                component: () =>
                    import('./components/Cadastro/Periodicidade/Editar.vue'),
                meta: { codModulo: 14, readonly: 0 },
            },
            {
                path: 'ver',
                component: () =>
                    import('./components/Cadastro/Periodicidade/Editar.vue'),
                meta: { codModulo: 14, readonly: 1 },
            },
            ]
        },
        {
            path: '/planoEquipamento',
            component: Home,
            children: [{
                path: '',
                component: () =>
                    import('./components/Cadastro/PlanoEquipamento/Criar.vue'),
                meta: { codModulo: 14, readonly: 0 },
            },
            ]
        },
        {
            path: '/compartimento',
            component: Home,
            children: [{
                path: '',
                component: () =>
                    import('./components/Cadastro/Compartimento/Lista.vue'),
                meta: { codModulo: 14, readonly: 1 },
            },
            {
                path: 'criar',
                component: () =>
                    import('./components/Cadastro/Compartimento/Criar.vue'),
                meta: { codModulo: 14, readonly: 0 },
            },
            {
                path: 'editar',
                component: () =>
                    import('./components/Cadastro/Compartimento/Editar.vue'),
                meta: { codModulo: 14, readonly: 0 },
            },
            {
                path: 'ver',
                component: () =>
                    import('./components/Cadastro/Compartimento/Editar.vue'),
                meta: { codModulo: 14, readonly: 1 },
            },
            ]
        },
        {
            path: '/departamento',
            component: Home,
            children: [{
                path: '',
                component: () =>
                    import('./components/Cadastro/Departamento/Lista.vue'),
                meta: { codModulo: 1, readonly: 1 },
            },
            {
                path: 'criar',
                component: () =>
                    import('./components/Cadastro/Departamento/Criar.vue'),
                meta: { codModulo: 1, readonly: 0 },
            },
            {
                path: 'editar',
                component: () =>
                    import('./components/Cadastro/Departamento/Editar.vue'),
                meta: { codModulo: 1, readonly: 0 },
            },
            {
                path: 'ver',
                component: () =>
                    import('./components/Cadastro/Departamento/Editar.vue'),
                meta: { codModulo: 1, readonly: 1 },
            },
            ],
            meta: { codModulo: 1 },
        }
    ]
});

router.beforeEach((to, from, next) => {
    const isLoginPage = to.path == '/login';
    const istokenReset = to.path == '/resetPassword';
    const loggedIn = localStorage.getItem('user');

    if (!isLoginPage && !loggedIn && !istokenReset) {
        return next('/login');
    }

    if (istokenReset) {
        return next();
    }
    if (loggedIn && isLoginPage) {
        return next('/');
    }

    if (loggedIn && JSON.parse(loggedIn).first) {
        if (to.path != '/change')
            return next('/change');
        else
            next();
    }

    if (to.matched.some(record => record.meta.codModulo)) {
        const user = JSON.parse(loggedIn);
        var roles = user.roles || user.Roles || []
        /*var i = roles.length;
        while (i--) {
            if (roles[i].idModulo === to.meta.codModulo) {
                next()
            }
            else{
                next({ path: '/' })
            }
        }*/
        const adminSpecialRoutes = [
            '/requisicao/aprovar',
            '/requisicao/inativar',
            '/requisicaoServico/aprovar',
            '/requisicaoServico/inativar',
            '/requisicaoServico/aprovarPedido',
            '/solicitacao/aprovar',
            '/solicitacao/inativar',
            '/mapaCotacao/aprovar',
            '/mapaCotacao/inativar',
            '/pedido/inativar'
        ];

        if ((user.admin ?? user.Admin) === true && adminSpecialRoutes.includes(to.path)) {
            next()
            return
        }

        var role = roles.find((r) => { return r.idModulo == to.meta.codModulo });
        if (role != null && to.meta.readonly) {
            next()
        } else if (role != null && role.escrita == !to.meta.readonly) {
            next()
        } else {
            next({ path: '/' })
        }

    } else {
        next()
    }
    /*
    if (!loggedIn) {
        next();
    }

    next();
    */
})

export default router
